import { render } from "./ComplimentaryTicketsTable.vue?vue&type=template&id=32596a40&scoped=true"
import script from "./ComplimentaryTicketsTable.vue?vue&type=script&lang=js"
export * from "./ComplimentaryTicketsTable.vue?vue&type=script&lang=js"

import "./ComplimentaryTicketsTable.vue?vue&type=style&index=0&id=32596a40&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32596a40"]])

export default __exports__